<template>
    <div>
        <div class="goods-list" v-for="(item, index) in likeInfo" :key="index" @click="goDetail(item,shop_type ? shop_type:1,is_buy_new)">
            <div class="goods-img">
                <img :src="item.recommend_image" alt="" />
            </div>
            <div class="goods-content">
                <div class="title line l-1">{{ item.store_name }}</div>
                <div class="intrduce line l-1">{{ item.store_info }}</div>
                <div class="money">
                    <div class="money-left">
                        <div class="mon-day">￥{{ item.price }}</div>
                        <div class="mon-del" v-if="item.ot_price">￥{{ item.ot_price }}</div>
                        <div class="span" v-if="item.gains!=0">
                            <img src="../assets/images/icon_up.png" alt="" v-if="item.gains==1" />
                            <img src="../assets/images/icon_down.png" alt="" v-if="item.gains==2" />
                            <div style="color:#D01112">{{item.gains_num}}%</div>
                        </div>
                    </div>
                    <div class="go-shop">立即购买</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { goShopDetail } from "@libs/order";
export default {
    name: "indexGoods",
    props: {
        likeInfo: Array,
        shop_type: Number, //1自营商品，2新人专区，3积分专区
        is_buy_new: 0, //1已经购买过新人商品了
    },
    data() {
        return {

        };
    },
    methods: {
        goDetail(item, shop_type, is_buy_new) {
            // if (is_buy_new == 1) {
            //     return this.$dialog.toast({ mes: '您已经在新人专区购买过商品了' })
            // }
            goShopDetail(item).then(() => {
                this.$router.push({ path: "/detail/" + item.id + "?shop_type=" + shop_type });
            });
        }
    }
};
</script>
<style scoped>
.goods-list {
    height: 242px;
    margin: 15px 11px auto 11px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
}

.goods-list .goods-img {
    width: 100%;
    height: 150px;
}

.goods-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.goods-list .goods-content {
    width: 100%;
    height: 91px;
    padding: 0 15px;
}

.goods-list .goods-content .title {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    line-height: 34px;
}

.goods-list .goods-content .intrduce {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
}

.goods-list .goods-content .money {
    display: flex;
    height: 38px;
    align-items: center;
    justify-content: space-between;
}

.goods-list .goods-content .money .money-left {
    display: flex;
    align-items: center;
}

.goods-list .goods-content .money .money-left .mon-day {
    font-size: 16px;
    font-weight: 600;
    color: #d01112;
}

.goods-list .goods-content .money .money-left .mon-del {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    padding-left: 10px;
    text-decoration: line-through;
}

.goods-list .goods-content .money .go-shop {
    width: 64px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #d01112;
    border-radius: 13px;
    color: #ffffff;
    font-size: 12px;
}

.span {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.span img {
    width: 15px;
    height: 9px;
}

.span div {
    padding-left: 5px;
}
</style>